import { render, staticRenderFns } from "./rowInfoDisplay.vue?vue&type=template&id=2a03f5f4&"
import script from "./rowInfoDisplay.vue?vue&type=script&lang=js&"
export * from "./rowInfoDisplay.vue?vue&type=script&lang=js&"
import style0 from "./rowInfoDisplay.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "rowInfoDisplay.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VIcon,
})
